import { useEffect, useState } from 'react';
import { leerSecretoDeUrl, limpiarUrl, type ClaveSecreto } from '../utils/secretoUrl';

/**
 * Lee el secreto de la URL una sola vez, lo guarda en el estado del componente y limpia la URL (LOG-5).
 * Los efectos que lo usan dependen de este valor y no de la URL: limpiar la barra no los vuelve a disparar.
 */
export const useSecretoDeUrl = (clave: ClaveSecreto, paramRuta?: string): string | null => {
  const [lectura] = useState(() => leerSecretoDeUrl(window.location, clave, paramRuta));

  useEffect(() => {
    if (lectura.secreto) limpiarUrl(lectura.rutaLimpia);
    // Una sola vez, con la lectura inicial.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return lectura.secreto;
};
